export default "__VITE_ASSET__BWHwTlCz__"